import { PORTABLE_TEXT_FIELDS } from './snippets';

export const getAllQuizSlugs = `*[_type == "quiz" && defined(slug.current) && active == true][]{
  "params": {
    "quiz": slug.current
  }
}`;

export const getQuizBySlug = `*[_type == "quiz" && slug.current == $slug && active == true][0]{
  _id,
  title,
  slug,
  "content": content[]{
    ${PORTABLE_TEXT_FIELDS}
  },
  metaTitle,
  metaDescription,
  startingQuestion->{
    _id,
    _type,
    questionText,
    helpText,
    answers[]{
      _key,
      answerText,
      nextStep{
        "questionRef": question._ref,
        "resultRef": result._ref
      }
    }
  }
}`;

// Fetch a single question by its _ref
export const getQuestionByRef = `*[_id == $ref][0]{
  _id,
  _type,
  questionText,
  helpText,
  answers[]{
    _key,
    answerText,
    nextStep{
      "questionRef": question._ref,
      "resultRef": result._ref
    }
  }
}`;

// Fetch a single result by its _ref
export const getResultByRef = `*[_id == $ref][0]{
  _id,
  _type,
  title,
  description,
  additionalContent,
  "recommendedProductIds": recommendedProducts[]->productId
}`;
